(ns cms.editor.ordered-elements
  (:require 
    [cms.editor.core :refer [resolve-schema
                             schema->enum
                             schema-editor
                             schema-in
                             populate]]
    [react-flip-move]
    [reagent.core :as r]
    [common.util :refer [new-uuid]]))

(defn- swap-indices [vector i1 i2]
  (let [e1 (get vector i1)
        e2 (get vector i2)]
    (if-not (and e1 e2)
      vector 
      (-> vector 
          (assoc i1 (get vector i2))
          (assoc i2 (get vector i1))))))

(defmethod schema-editor :OrderedElements [url defs schema node&]
  (let [{:strs [Seq Elements]} @node&
        
        addt (schema-in 
               defs schema 
               ["properties" "Elements" 
                "additionalProperties"])]
    
    [:details
     {:open true} 
     [:summary]
     [:table {:class :OrderedElements}
      (into  
        [:> react-flip-move {:type-name "tbody"}]
        (concat 
          (for [[key i] (map vector Seq (range))]
            (let [val (get Elements key)]
              [:tr
               {:key i} 
               (let [sub-url (str url "/Elements/" key)]
                 [:td (schema-editor
                        sub-url
                        defs addt
                        (r/cursor node& ["Elements" key]))])
               
               [:td
                {:style {:vertical-align :top}}
                [:div.column 
                 [:button 
                  {:on-click 
                   #(swap! node& update "Seq"
                           swap-indices i (dec i))}
                  "⬆️"]
                 [:button 
                  {:on-click 
                   #(swap! node& update "Seq"
                           swap-indices i (inc i))}
                  "⬇️"]
                 
                 [:button 
                  {:on-click 
                   #(swap! node& 
                           (fn [{:strs [Seq Elements] :as node}]
                             (let [new-seq (remove #{key} Seq)]
                               (-> node 
                                   (update "Elements" (fn [es] (select-keys new-seq es)))
                                   (assoc "Seq" (vec new-seq))))))}
                  "🗑"]]]]))
          
          [[:tr {:key "add"}
            [:td   
             [:button 
              {:on-click 
               #(swap! 
                  node& 
                  (fn [n]
                    (let [key (new-uuid)]
                      (-> n 
                          (update "Elements" assoc key (populate defs addt))
                          (update "Seq" (comp vec conj) key)))))}
              "➕"]]]]))]]))
